import useSupplier from "./useSupplier";

export const useIsSupplierCompanyAdmin = (): [boolean, boolean] => {
  const [supplier, isLoading] = useSupplier();

  return [
    !!supplier?.supplierCompanyToSuppliers?.[0]?.isAdmin,
    isLoading || !supplier,
  ];
};
